export enum FilterType {
  Userdefined = 'Userdefined',
  Predefined= 'Predefined',
  Deadline= 'Deadline'
}
